import { Translation, TRANSLOCO_CONFIG, TRANSLOCO_LOADER, translocoConfig, TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { environment } from '../../../environments/environment';
import { TranslocoHttpLoader } from './transloco.http-loader';

@NgModule({
    exports: [
        TranslocoModule
    ],
    providers: [
        {
            // Provide the default Transloco configuration
            provide: TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs: [
                    {
                        id: 'es-ES',
                        label: 'Español'
                    },
                    {
                        id: 'en-GB',
                        label: 'English'
                    },
                    {
                        id: 'pt-PT',
                        label: 'Português'
                    }
                ],
                defaultLang: 'es-ES',
                fallbackLang: 'es-ES',
                reRenderOnLangChange: true,
                prodMode: environment.production
            })
        },
        {
            // Provide the default Transloco loader
            provide: TRANSLOCO_LOADER,
            useClass: TranslocoHttpLoader
        },
        provideAppInitializer(() => {
            const translocoService = inject(TranslocoService);
            const defaultLang = translocoService.getDefaultLang();
            translocoService.setActiveLang(defaultLang);
            return translocoService.load(defaultLang);
        })
    ]
})
export class TranslocoCoreModule {
}
